import { NotificationGroup } from "@progress/kendo-react-notification";
import { useDispatch, useSelector } from "react-redux";

import { clearErrorsAction } from "../../../../actions/errors";

import Snack from "./Snack";
import * as styles from "./styles.module.scss";

import type { ErrorDetails } from "../../../../models";
import type { State } from "../../../../reducers";

const SHOW_TIME = process.env.REACT_APP_NOTIFICATION_DISPLAY_INTERVAL ?? 10000;

const Snackbar = () => {
  const dispatch = useDispatch();

  const messages = useSelector<State, ErrorDetails[]>(({ ui }) => ui.errors);

  const handleHideMessage = (index: number) => {
    dispatch(clearErrorsAction(index));
  };

  return (
    <NotificationGroup className={styles.group}>
      {messages.map((item, index) => (
        <Snack
          message={item}
          showTime={Number(SHOW_TIME)}
          key={index}
          onHide={() => {
            handleHideMessage(index);
          }}
        />
      ))}
    </NotificationGroup>
  );
};

export default Snackbar;
